<template>
  <div class="container mescroll-touch" :class="meetinginfo.BackGroundPic ? 'contback' : ''">
    <!-- <img src="../../assets/images/acmedtopback.png" class="img" /> -->
    <div class="total">
      <img v-if="meetinginfo.BackGroundPic" :src="meetinginfo.BackGroundPic" class="contimg" />
      <el-carousel :interval="5000" arrow="always" class="elbanner">
        <el-carousel-item v-for="item in bannerlist" :key="item">
          <img :src="item.ImgUrl" class="bannerimg" @click="jumpimgurl(item.LinkUrl, item.Id, item.Description)" />
        </el-carousel-item>
      </el-carousel>
      <div class="btnlist">
        <div class="btnrow">
          <div class="btnsimple">
            <div class="btnincolnew">
              <div class="btnsmall1">
                <div class="timetitle" v-if="isopen == 0 && meetinginfo.CountdownSwitch == true"><img
                    src="../../assets/images/timestart.png" class="bannerimg" />
                </div>
                <div class="btnsmall2 btnheng">
                  <!-- <img src="../../assets/images/xximg.png" class="btnmimg3" /> -->
                  <div class="timem" v-if="isopen == 0 && meetinginfo.CountdownSwitch == true"><span class="timel">{{
                    day
                      }}</span><span class="timeguding">天</span></div>
                  <div class="timem" v-if="isopen == 1 && meetinginfo.CountdownSwitch == true"><img
                      src="../../assets/images/mtstart.png" class="timeimg" />
                  </div>
                  <div class="timem" v-if="isopen == 2 && meetinginfo.CountdownSwitch == true"><img
                      src="../../assets/images/mtover.png" class="timeimg" />
                  </div>
                  <div class="times" v-if="isopen == 0 && meetinginfo.CountdownSwitch == true">
                    <div class="bold timel">{{ hh }}</div><span class="timeguding">时</span>
                    <div class="bold timel">{{ mm }}</div><span class="timeguding">分</span>
                    <div class="bold timel">{{ ss }}</div><span class="timeguding">秒</span>
                  </div>
                  <!-- <div class="btntext2">基本<br />信息</div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btnrowround">
          <div class="rowinner" v-for="(item, index) in modellist" :key="index" @click="gomodel(item)">
            <img :src="item.Icon" class="rowbtn" />
            <div class="rowname">{{ item.Name }}</div>
          </div>
        </div>
      </div>
      <div class="tcout" v-if="showtc == 1">
        <div class="tcimg">
          <div class="jumptc" @click="gotcurl(list.LinkUrl, list.Id, list.Description)">
            <img :src="list.ImgUrl" class="tcimgin" />
          </div>
          <div class="close" @click="closebtn()">
            <img src="../../assets/images/tcclose.png" class="tcimgin" />
          </div>
        </div>

        <div class="back"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
export default {
  name: 'custom',
  data() {
    return {
      day: 0,
      hh: 0,
      mm: 0,
      ss: 0,
      list: {},
      showtc: 0,
      isopen: 10,
      bannerlist: [],
      meetinginfo: [],
      modellist: [],
      p1: '',
      p2: '',
      timer: '',
    }
  },
  mixins: [mixin],
  components: {
  },
  created() {
    this.getdahui();
  },
  methods: {
    getdahui() {
      let that = this
      this.$axios
        .get("/api/api/web/Activity/GetModel?id=" + this.$route.query.Id)
        .then((res) => {
          that.meetinginfo = res.Data
          this.initzqShare(that.meetinginfo.ForwardMainTitle, that.meetinginfo.ForwardSubTitle, that.meetinginfo.ForwardPic);
          document.title = this.meetinginfo.Title;
          this.getlunbo();
          this.getimg();
          this.count();
          this.$axios
            .post("/api/api/web/Activity/getModuleList", {
              ActivityId: that.$route.query.Id
            })
            .then((res) => {
              that.modellist = res.Data
              for (var i = 0; i < that.modellist.length; i++) {
                if (that.modellist[i].Position1 && that.modellist[i].Position2) {
                  that.p1 = that.modellist[i].Position1
                  that.p2 = that.modellist[i].Position2
                }
              }
            });
        });
    },
    gotcurl(u, id, d) {
      if (u) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: d,
            TCode: 'activity_link',
            Rid: id,
          },)
          .then((res) => {
            window.location.href = u;
          });
      }
    },
    getimg() {
      let that = this
      let isClose = sessionStorage.getItem("acmedLinkClose");
      if (!isClose) {
        this.$axios.post('/api/api/web/activity/GetActivityLink', {
          Code: this.meetinginfo.Code,
        }).then(res => {
          // console.log(res.data.Data)
          if (res.Data.length > 0) {
            that.showtc = 1
            that.list = res.Data[0]
          } else {
            that.showtc = 0
          }
          // console.log(this.list)
        })
      }
    },
    getlunbo() {
      let that = this
      this.$axios.post('/api/api/web/activity/GetActivityBanner', {
        Code: this.meetinginfo.Code,
      }).then(res => {
        // console.log(res.data.Data)
        if (res.Data) {
          that.bannerlist = res.Data
        }
        // console.log(this.list)
      })
    },
    gomodel(i) {
      let that = this;
      // console.log(i)
      if (i.MType == 10) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '大会模块',
            TCode: 'activity_module',
            Rid: i.Id,
            UpId: that.$route.query.Id
          }).then(res => {
            this.$router.push({
              path: "customimg",
              query: {
                ActivityId: that.meetinginfo.Id,
                Id: i.Id,
                code: that.meetinginfo.Code,
                Title: that.meetinginfo.Title,
                Name: i.Name
              },
            });
          })
      } else if (i.MType == 20) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '大会模块',
            TCode: 'activity_module',
            Rid: i.Id,
            UpId: that.$route.query.Id
          }).then(res => {
            window.location.href = i.mUrl
          })
      } else if (i.MType == 30) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '大会模块',
            TCode: 'activity_module',
            Rid: i.Id,
            UpId: that.$route.query.Id
          }).then(res => {
            this.$router.push({
              path: "customtimeline",
              query: {
                ActivityId: that.meetinginfo.Id,
                Id: i.Id,
                code: that.meetinginfo.Code,
                Title: that.meetinginfo.Title,
                Name: i.Name
              },
            });
          })
      } else if (i.MType == 40) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '大会模块',
            TCode: 'activity_module',
            Rid: i.Id,
            UpId: that.$route.query.Id
          }).then(res => {
            this.$router.push({
              path: "customjiansuo",
              query: {
                ActivityId: that.meetinginfo.Id,
                Id: i.Id,
                code: that.meetinginfo.Code,
                Title: that.meetinginfo.Title,
                Name: i.Name
              },
            });
          })
      } else if (i.MType == 50) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '大会模块',
            TCode: 'activity_module',
            Rid: i.Id,
            UpId: that.$route.query.Id
          }).then(res => {
            this.$router.push({
              path: "customtextarea",
              query: {
                ActivityId: that.meetinginfo.Id,
                Id: i.Id,
                code: that.meetinginfo.Code,
                Title: that.meetinginfo.Title,
                Name: i.Name
              },
            });
          })
      } else if (i.MType == 60) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: '大会模块',
            TCode: 'activity_module',
            Rid: i.Id,
            UpId: that.$route.query.Id
          }).then(res => {
            this.$router.push({
              path: "custommap",
              query: {
                ActivityId: that.meetinginfo.Id,
                Id: i.Id,
                code: that.meetinginfo.Code,
                Title: that.meetinginfo.Title,
                Name: i.Name,
                p1: that.p1,
                p2: that.p2,
              },
            });
          })
      }
    },
    closebtn() {
      this.showtc = 0;
      sessionStorage.setItem("acmedLinkClose", "1");
    },
    count() {
      let that = this
      // 设置倒计时的结束时间为未来某个时间
      var StartTime = new Date(that.meetinginfo.StartTime);
      var jieshuTime = new Date(that.meetinginfo.EndTime);
      const startTimestamp = StartTime.getTime();
      const endTimestamp = jieshuTime.getTime();
      // 每秒执行一次
      that.timer = setInterval(function () {
        // 获取当前时间和结束时间的时间差
        var nowTime = new Date();
        const nowTimestamp = nowTime.getTime();
        if (endTimestamp > startTimestamp && startTimestamp > nowTimestamp) {
          // 情况1：结束时间 > 开始时间 > 当前时间（会议未开始）
          that.isopen = 0;
          var timeDiff = StartTime.getTime() - nowTime.getTime();
          var days = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
          var hours = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
          var minutes = Math.floor((timeDiff / 1000 / 60) % 60);
          var seconds = Math.floor((timeDiff / 1000) % 60);
          that.ss = seconds;
          that.hh = hours;
          that.day = days;
          that.mm = minutes;
        } else if (endTimestamp > nowTimestamp && nowTimestamp > startTimestamp) {
          // 情况2：结束时间 > 当前时间 > 开始时间（会议进行中）
          that.isopen = 1;
        } else if (nowTimestamp >= endTimestamp) {
          // 情况3：当前时间 >= 结束时间（会议已结束）
          that.isopen = 2;
        }
        // 计算剩余时间
        // 将剩余时间显示在页面上
        // var countdownDiv = document.getElementById("countdown");
        // countdownDiv.innerHTML = "距离2024年元旦还有：" + days + "天" + hours + "小时" + minutes + "分" + seconds + "秒";
        // console.log("距离还有：" + this.day + "天" + hours + "小时" + minutes + "分" + this.ss + "秒")
      }, 1000);
    },
    jumpimgurl(url, id, d) {
      let that = this
      if (url) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: d,
            TCode: 'activity_banner',
            Rid: id,
            UpId: that.$route.query.Id
          })
          .then((res) => {
            window.location.href = url;
          });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100%;
  width: 100%;
  background: rgb(228, 236, 255);
  position: relative;
}

.img {
  display: block;
  width: 100%;
  margin-bottom: .2rem
}

.guanggaoimg {
  display: block;
  width: 92%;
  margin: auto;
  margin-bottom: .2rem;
  padding-top: 0.3rem;
}

.btnlist {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 4%;
  box-sizing: border-box;
  background: #e4ecff;
  z-index: 100;
}

.btnrow {
  display: flex;
  flex-direction: row;
  z-index: 100;
  // margin-bottom: .2rem;
}

.btnmiddle {
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  width: 33%;
  border-radius: 5px;
  padding: .2rem 0;
  box-shadow: -1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  margin-right: .2rem;
  display: flex;
  flex-direction: column;
}

.btnmiddleleft {
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  width: 33%;
  border-radius: 5px;
  padding: .3rem 0;
  box-shadow: -1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  margin-left: .2rem;
}

.btnmimg {
  display: block;
  width: 22%;
  margin: auto;
  margin-right: 10%;
}

.btnimgout {
  text-align: right;
  width: 100%;
}

.btntext {
  display: block;
  width: 100%;
  font-size: .4rem;
  color: #ffd7c0;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 10%;
}

.btnlarge {
  display: flex;
  flex-direction: column;
  width: 66%;
  background-image: linear-gradient(to right, #003583, #003bb9);
  box-shadow: 0 0.026667rem 0.133333rem 0 rgba(0, 0, 0, 0.1);
  border-radius: 0.133333rem;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0;
}

.left50 {
  margin-right: 2%
}

.btn50 {
  display: flex;
  flex-direction: column;
  width: 49%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0;
}

.btn111 {
  display: flex;
  flex-direction: row;
  width: 100%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0;
}

.btnmimg1 {
  display: block;
  width: 11%;
  margin: auto;
  margin-right: 5%;
}

.btnmimg2 {
  display: block;
  width: 14%;
  margin: auto;
  margin-right: 7%;
}

.btnmimg111 {
  display: block;
  width: 21%;
  margin: auto;
  margin-right: 13%;
}

.btntext1 {
  display: block;
  width: 100%;
  font-size: .4rem;
  color: #ffd7c0;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 5%;
}

.btntext2 {
  display: block;
  width: 100%;
  font-size: .4rem;
  color: #ffd7c0;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 7%;
}

.btntext111 {
  display: block;
  width: 100%;
  font-size: .4rem;
  color: #ffd7c0;
  font-weight: bold;
  text-align: left;
  box-sizing: border-box;
  padding-left: 4%;
}

.btnincol {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  top: 0;
  justify-content: space-between;
  height: 100%;
}

.btnsmall {
  display: flex;
  flex-direction: row;
  width: 100%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.11rem 0;
  position: relative;
  margin-top: 0.1rem;
}

.btnsmall1 {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  // padding: 0.18rem 0;
}

.btnsmall2 {
  display: flex;
  flex-direction: column;
  width: 100%;
  // background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  // box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.05rem 0;
  // position: absolute;
  // left: 0;
  // top: 0;
  color: #003583;
  // font-weight: bold;
}

.timem {
  font-size: .4rem;
}

.times {
  font-size: .4rem;
}

.timel {
  font-size: 0.6rem;
  font-weight: bold;
  vertical-align: middle;
  margin: 0 0.1rem;
  // background: #fff;
  padding: 0 .1rem;
}

.btnsimple {
  position: relative;
  width: 100%;
}

.btnincolnew {
  position: unset;
}

.btnheng {
  flex-direction: row;
  margin-bottom: .2rem
}

.tcout {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 500;

  .tcimg {
    display: block;
    width: 80%;
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
    z-index: 500;

    .close {
      width: 1rem;
      height: 1rem;
      display: block;
      margin: auto;
      margin-top: 0.2rem;
    }

    img {
      display: block;
      width: 100%;
    }
  }

  .back {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 25;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
  }
}

// .jumptc {}

.btnhide {
  opacity: 0;
  font-size: .2rem;
}

.btnhide1 {
  opacity: 0;
  font-size: .8rem;
}

.bold {
  display: inline-block;
  font-weight: bold;
}

.bannerimg {
  width: 100%;
  display: block;
}

.elbanner {
  position: relative;
  height: 3.5rem;
  width: 93%;
  margin: auto;
  overflow: hidden;
  padding-top: .3rem;
  z-index: 100;
}

::v-deep .el-carousel__container {
  height: 100%;
}

::v-deep .el-carousel__indicators--horizontal {
  bottom: 5%;
}

.timetitle {
  margin-bottom: .2rem;
  color: #003583;
}

.timeguding {
  vertical-align: middle;
}

.rowbtn {
  background: #003583;
  width: 70%;
  display: block;
  border-radius: .4rem;
  margin: auto;
}

.btnrowround {
  display: flex;
  flex-direction: row;
  margin-bottom: .2rem;
  align-items: center;
  justify-content: start;
  flex-wrap: wrap;
  z-index: 100;
}

.rowinner {
  width: 31%;
  margin: 0.05rem .1rem;
  border-radius: .4rem;
  overflow: hidden;
  margin-bottom: .2rem;
}

.rowname {
  text-align: center;
  color: #003583;
  font-weight: bold;
}

.timeimg {
  width: 100%;
  display: block;
}

.total {
  // position: relative;
  width: 100%;
  height: 100%;
}

.contimg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
</style>